<template>
<v-app>
    <v-snackbar
      v-model="error"
      border="left"
      absolute
      color="red darken-1"
      dark
      bottom
      left
      :timeout="0"
      class="mx-2 mt-3"
    >
      <span class="d-flex align-center title pa-3 text-truncate">
        <v-icon class="mr-3">mdi-shield-alert-outline</v-icon> <span>{{ error }}</span>
      </span>
    </v-snackbar>
    <v-snackbar
      v-model="info"
      border="left"
      absolute
      color="blue"
      dark
      bottom
      left
      :timeout="0"
      class="mx-2 mt-3"
    >
      <span class="d-flex align-center title pa-3 text-truncate">
        <span class="mr-3">👋</span> <span>{{ info }}</span>
      </span>
      <v-btn small icon @click="clearInfo()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <component v-if="!this.$route.meta.hideToolbar" :is="((this.$route.meta.toolbar)||'BaseToolbar')">
    </component>
    <v-content :class="this.$route.meta.hideToolbar?'':'content'" class="grey lighten-4">
      <v-fade-transition>
        <router-view></router-view>
      </v-fade-transition>
    </v-content>
    <v-dialog
      :value="dialogContact"
      width="600"
      scrollable
      light>
      <v-card>
          <v-card-title
            class="headline elevation-3 primary white--text py-4"
            primary-title>
            Contact
            <v-icon large class="ml-auto white--text">mdi-person</v-icon> 
          </v-card-title>
          <v-card-text class="pa-6">
              <v-form autocomplete="off" v-model="valid" ref="formContact">
                <v-text-field v-model="contact.name" label="Name">
                </v-text-field>
                <v-text-field v-model="contact.email" 
                    :rules="[rules.required, rules.email]"
                    type="email"
                    label="Email">
                </v-text-field>
                <v-textarea v-model="contact.message"
                    :rules="[rules.required]"
                    label="Message (questions, comments or feedback)">
                </v-textarea>
                <v-text-field v-model="human" 
                    :rules="[rules.required, rules.human]"
                    placeholder="Answer"
                    label="What is 2 + 5?">
                </v-text-field>
              </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn
                outlined
                color="primary"
                class="px-3 mr-2"
                @click="toggleContact()">
                CLOSE
            </v-btn>
            <v-btn
                color="primary"
                class="px-3 white--tex"
                :disabled="!valid"
                @click="submitContact()">
                SEND IT
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import { BaseToolbar } from '@/components/toolbars'

export default {
  name: 'App',
  data: () => ({
    valid: false,
    human: null,
    contact: {},
    rules: {
      required: value => !!value || 'required',
      human: value => (value==="7") || 'enter the sum of 2 + 5',
      email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'invalid e-mail'
      }
    }
  }),
  components: {
    BaseToolbar,
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      error: state => state.global.error,
      info: state => state.global.info,
      dialogContact: state => state.global.dialogContact
    })
  },
  methods: {
    clearError() {
      this.$store.commit('CLEAR_ERROR')
    },
    clearInfo() {
      this.$store.commit('CLEAR_INFO')
    },
    toggleContact() {
      this.$store.commit('TOGGLE_CONTACT_FORM')
    },
    submitContact() {
      this.$store.dispatch('SUBMIT_CONTACT_FORM', this.contact)
      setTimeout(() => {
        this.$refs.formContact.reset()
      }, 200)
    }
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
  .v-application {
    font-family: 'Poppins',sans-serif !important;
  }
  .v-application .v-content__wrap {
    display: flex;
    flex-direction: column;
  }
  .text-circular {
    font-family: 'Poppins',sans-serif !important;
  }
  .text-none {
    text-transform: none;
    text-decoration: none;
    font-family: Poppins, sans-serif;
  }
  .w-100 {
    width: 100%;
  }
  .min-vh-100 {
    min-height: 100vh;
  }
  .position-absolute {
    position: absolute;
  }
  .position-relative {
    position: relative;
  }
  .v-application .v-snack {
    z-index: 5;
  }
  .v-application .v-snack .v-snack__content {
    padding: 0 4px;
    min-height: 28px;
    line-height: 1;
    justify-content: center;
  }
  .v-application .v-snack--bottom {
    bottom: 6px;
    position:fixed;
  }
</style>
